// src/types/formTypes.ts

export interface PersonalInfoValues {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  mobileNumber: string;
  permanentHomeAddress: string;
  email: string;
  city: string;
  applicationStatus: string;
  profilePhoto: File | null;
  remarks: string | null;
}

export interface EducationEntry {
  degreeQualification: string;
  institution: string;
  // New fields from the screenshot:
  schoolCollegeAddress: string; // Added
  nameOfUniversity: string; // Added
  course: string; // Added
  marksObtainedCGPA: string; // Added
  yearOfPassing: string; // Added
  principalName: string; // Added
  principalContactNumber: string; // Added
  uploadMarksheet: File | null; // Added, considering it's a file upload
  // ... (Keep existing fields if they map to your form)
  yearOfCompletion: string; // Already exists
  gpaPercentage: string; // Already exists
}

export interface PresentEducationValues {
  currentProgram: string;
  currentInstitution: string;
  expectedCompletionYear: string;
  currentGpaPercentage: string;
}

export interface AchievementEntry {
  description: string;
}

export interface FamilyDetailsValues {
  fathersName: string;
  mothersName: string;
  numberOfSiblings: number;
  familyIncome: number;
}

export interface ScholarshipPurposeValues {
  purposeExplanation: string;
}

export interface DocumentEntry {
  fileName: string;
  file: File | null | undefined; // This is correct
  uploadedDate?: string;
}

export interface BankDetailsValues {
  bankName: string;
  accountHolderName: string;
  accountNumber: string;
  ifscCode: string;
}

// export interface ScholarshipApplicationFormValues {
//   personalInfo: PersonalInfoValues;
//   completedEducation: EducationEntry[];
//   presentEducation: PresentEducationValues;
//   achievements: AchievementEntry[];
//   familyDetails: FamilyDetailsValues;
//   scholarshipPurpose: ScholarshipPurposeValues;
//   uploadedDocuments: DocumentEntry[];
//   bankDetails: BankDetailsValues;
// }

export const InitialValues = {
  personalInfo: {
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    mobileNumber: "",
    email: "",
    gender: "",
    socialMediaHandle: "",
    socialMediaHandleFB: "",
    socialMediaHandleInstagram: "",
    socialMediaHandleLinkedIn: "",
    permanentHomeAddress: "",
    city: "",
    state: "",
    district: "",
    zipcode: "",
    profilePhoto: null as File | null,
    profilePhotoName: "",
  },
  completedEducation: [
    {
      id: null,
      title: "Secondary Education",
      nameSchoolCollege: "",
      schoolCollegeAddress: "",
      nameOfUniversity: "",
      course: "",
      stream: "",
      marksObtainedCGPA: "",
      yearOfPassing: "",
      principalName: "",
      principalContactNumber: "",
      uploadMarksheet: null as File | null,
      uploadMarksheetPreview: "",
      fileName: "",
      fileType: "",
      docName: "",
    },
    {
      id: null,
      title: "Higher Secondary Education",
      nameSchoolCollege: "",
      schoolCollegeAddress: "",
      nameOfUniversity: "",
      course: "",
      stream: "",
      marksObtainedCGPA: "",
      yearOfPassing: "",
      principalName: "",
      principalContactNumber: "",
      uploadMarksheet: null as File | null,
      uploadMarksheetPreview: "",
      fileName: "",
      fileType: "",
    },
    {
      id: null,
      title: "Graduation",
      nameSchoolCollege: "",
      schoolCollegeAddress: "",
      nameOfUniversity: "",
      course: "",
      stream: "",
      marksObtainedCGPA: "",
      yearOfPassing: "",
      principalName: "",
      principalContactNumber: "",
      uploadMarksheet: null as File | null,
      uploadMarksheetPreview: "",
      fileName: "",
      fileType: "",
    },
    {
      id: null,
      title: "Post Graduation",
      nameSchoolCollege: "",
      schoolCollegeAddress: "",
      nameOfUniversity: "",
      course: "",
      stream: "",
      marksObtainedCGPA: "",
      yearOfPassing: "",
      principalName: "",
      principalContactNumber: "",
      uploadMarksheet: null as File | null,
      uploadMarksheetPreview: "",
      fileName: "",
      fileType: "",
    },
  ],
  presentEducation: {
    id: null,
    nameSchoolorCollege: "",
    schoolCollegeAddress: "",
    nameOfUniversity: "",
    course: "",
    stream: "",
    yearOfAdmission: "",
    currentSemester: "",
    courseDuration: "",
    principalName: "",
    principalContactNumber: "",
    courseFees: "",
    paymentFrequency: "",
    totalFeesPaid: "",
  },
  achievementsInfo: [
    {
      id: null,
      docName: "",
      fileName: "",
      file: null as File | null,
      uploadPreview: "",
      fileType: "",
      docFileName: "",
    },
  ],
  familyDetails: {
    id: null,
    fathersName: "",
    mothersName: "",
    guardiansName: "",
    fathersOccupation: "",
    mothersOccupation: "",
    familyIncome: "",
    contactNumber: "",
    siblings: [
      {
        id: null,
        name: "",
        relationship: "",
        qualification: "",
        sisterHusbandName: "",
        sisterHusbandOccupation: "",
      },
    ],
  },
  scholarshipPurpose: {
    purposeExplanation: "",
    knowApplication: "",
    otherScholarships: [
      {
        id: null,
        scholarshipsName: "",
        scholarshipsAmount: "",
      },
    ],
  },
  // uploadedDocuments: {
  //   id: 0,
  //   fileName: "",
  //   file: null as File | null,
  //   documentsPreview: "",
  // },
  bankDetails: [
    {
      id: null,
      bankType: "Student",
      bankName: "",
      accountHolderName: "",
      accountNumber: "",
      ifscCode: "",
      branchName: "",
      isPrimary: false
    },
    {
      id: null,
      bankType: "Father",
      bankName: "",
      accountHolderName: "",
      accountNumber: "",
      ifscCode: "",
      branchName: "",
      isPrimary: false
    },
    {
      id: null,
      bankType: "Mother",
      bankName: "",
      accountHolderName: "",
      accountNumber: "",
      ifscCode: "",
      branchName: "",
      isPrimary: false
    },
    // {
    //   id: null,
    //   bankType: "College/School",
    //   bankName: "",
    //   accountHolderName: "",
    //   accountNumber: "",
    //   ifscCode: "",
    //   branchName: "",
    // }
  ],
};
export const InitialValuesView = {
  personalInfo: {
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    mobileNumber: "",
    email: "",
    gender: "",
    socialMediaHandle: "",
    socialMediaHandleFB: "",
    socialMediaHandleInstagram: "",
    socialMediaHandleLinkedIn: "",
    permanentHomeAddress: "",
    city: "",
    state: "",
    district: "",
    zipcode: "",
    profilePhoto: "",
    profilePhotoName: "",
  },
  completedEducation: [
    {
      id: null,
      title: "",
      nameSchoolCollege: "",
      schoolCollegeAddress: "",
      nameOfUniversity: "",
      course: "",
      stream: "",
      marksObtainedCGPA: "",
      yearOfPassing: "",
      principalName: "",
      principalContactNumber: "",
      uploadMarksheet: null as File | null,
      uploadMarksheetPreview: "",
      fileName: "",
      fileType: "",
      docName: "",
    },
  ],
  presentEducation: {
    id: null,
    nameSchoolorCollege: "",
    schoolCollegeAddress: "",
    nameOfUniversity: "",
    course: "",
    stream: "",
    yearOfAdmission: "",
    currentSemester: "",
    courseDuration: "",
    principalName: "",
    principalContactNumber: "",
    courseFees: "",
    paymentFrequency: "",
    totalFeesPaid: "",
  },
  achievementsInfo: [
    {
      id: null,
      docName: "",
      fileName: "",
      file: null as File | null,
      uploadPreview: "",
      fileType: "",
      docFileName: "",
    },
  ],
  familyDetails: {
    fathersName: "",
    mothersName: "",
    guardiansName: "",
    fathersOccupation: "",
    mothersOccupation: "",
    familyIncome: "",
    contactNumber: "",
    siblings: [
      {
        id: null,
        name: "",
        relationship: "",
        qualification: "",
        sisterHusbandName: "",
        sisterHusbandOccupation: "",
      },
    ],
  },
  scholarshipPurpose: {
    purposeExplanation: "",
    knowApplication: "",
    otherScholarships: [
      {
        id: null,
        scholarshipsName: "",
        scholarshipsAmount: "",
      },
    ],
  },
  uploadedDocuments: {
    id: null,
    fileName: "",
    docName: "",
    file: null as File | null,
    documentsPreview: "",
    fileType: "",
  },
  bankDetails: [
    {
      id: null,
      title: 'Student',
      bankName: "",
      accountHolderName: "",
      accountNumber: "",
      ifscCode: "",
      branchName: "",
      isPrimary: false,
    },
     
  ],
};

export const InitialValuesEvaluation = {
  interviewer: "",
  remarks: "",
  sanctionAmount: null,
  coordinator: "",
  decision: "",
};

export const InitialValuesFundAllocation = {
  startDate: "",
  endDate: "",
  firstpayment: null,
  firstpaymentdate:null,
  funds: [
    {
      id: "",
      purpose: "",
      allocationAmount: "",
      frequency: "",
      installments: "",
      totalAmount: "",
      is_disabled: false,
    },
  ],
  firstpaymentpurpose: "",
};

export interface FundAddPaymentForm {
  fund_disburstment_amt: number;
  payment_date: Date;
  purpose: number;
  transaction_number: string;
  cheque_details: string;
  installment_paid: number;
  next_installment_dt:Date;
  next_installment_purpose:string;
  next_installment_amt: number;
  transaction_ref_no: string;
  description: string;
  new_purpose: any[];
}
export interface FundEditPaymentForm {
  fund_disburstment_amt: number;
  payment_date: Date;
  purpose: number;
  transaction_number: string;
  cheque_details: string;
  installment_paid: number;
  next_installment_dt:Date;
  next_installment_purpose:string;
  next_installment_amt: number;
  transaction_ref_no: string;
  DD_number: string;
  description: string;
  dropdownKeyMap: string;
}

export interface FundExpenseDetailForm {
  expense_purpose: string;
  expense_date: Date;
  receipt_url: (string | undefined)[];
  amount: number;
  verification_comments: string;
}

export interface StudentEvaluationFormType {
  evaluator_name: string;
  interview_date: string;
  evaluation_outcome: string;

}